export default {
    cn: {
        mtclient: {
            indexText: 'MT用户列表',
            loginText: '账号',
            search: '搜索',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            tableHead: [
                { key: 'enable', name: '启用', sort: true },
                { key: 'LOGIN', name: '账号', sort: true },
                { key: 'NAME', name: '名称', sort: true },
                { key: 'GROUP', name: '组别', sort: true },
                { key: 'EMAIL', name: '电邮', sort: true },
            ],
            status: ['禁用', '启用'],
        }
    },
    hk: {
        mtclient: {
            indexText: 'MT用戶列表',
            loginText: '賬號',
            search: '搜索',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            nodata: "沒有查詢到數據",
            tableHead: [
                { key: 'enable', name: '啟用', sort: true },
                { key: 'LOGIN', name: '賬號', sort: true },
                { key: 'NAME', name: '名稱', sort: true },
                { key: 'GROUP', name: '組別', sort: true },
                { key: 'EMAIL', name: '電郵', sort: true },
            ],
            status: ['禁用', '啟用'],
        }
    },
    en: {
        mtclient: {
            indexText: 'MT Client List',
            loginText: 'Login',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            nodata: "No data found",
            tableHead: [
                { key: 'enable', name: 'Enable', sort: true },
                { key: 'LOGIN', name: 'Login', sort: true },
                { key: 'NAME', name: 'Name', sort: true },
                { key: 'GROUP', name: 'Group', sort: true },
                { key: 'EMAIL', name: 'Email', sort: true },
            ],
            status: ['Disable', 'Enable'],
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/Sale/mtclient.js